var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGiftOutlined = function SvgGiftOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#giftOutlined_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.41 6.6h-2.2c.25-.42.4-.9.4-1.42a2.3 2.3 0 0 0-2.3-2.3h-.32c-1.23 0-2.32.61-2.99 1.54a3.68 3.68 0 0 0-2.99-1.54h-.32a2.3 2.3 0 0 0-2.3 2.3c0 .52.15 1 .4 1.42H4.55c-.85 0-1.54.69-1.54 1.54v1.72c0 .78.58 1.42 1.34 1.52v7.34c0 1.28 1.04 2.31 2.31 2.31h10.73c1.28 0 2.31-1.04 2.31-2.31v-7.35c.71-.14 1.25-.76 1.25-1.51V8.14c0-.85-.69-1.54-1.54-1.54m0 1.4c.08 0 .14.06.14.14v1.72c0 .08-.06.14-.14.14h-4.9V8zm-4.42-3.72h.32c.5 0 .9.4.9.9 0 .77-.62 1.39-1.39 1.39H12.7a2.29 2.29 0 0 1 2.29-2.29m-6.3 0h.32a2.29 2.29 0 0 1 2.29 2.29H9.18c-.77 0-1.39-.62-1.39-1.39 0-.5.4-.9.9-.9M4.41 8.14c0-.08.06-.14.14-.14h4.94v2H4.55c-.08 0-.14-.06-.14-.14zm5.08 11.5H6.66c-.5 0-.91-.41-.91-.91v-7.32h3.74v8.24zm3.61 0h-2.21V8.37h2.21zm5.2-.91c0 .5-.41.91-.91.91H14.5V11.4h3.8v7.33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "giftOutlined_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgGiftOutlined;